"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const x_date_pickers_1 = require("@mui/x-date-pickers");
/**
 *
 * @category component
 */
function DatePickerX(props) {
    const { helperText, error, slotProps = {}, ...restProps } = props;
    const desktopDatePickerProps = {
        closeOnSelect: true,
        ...restProps,
        slotProps: {
            ...slotProps,
            textField: {
                ...slotProps?.textField,
                helperText,
                error,
            },
        },
    };
    return react_1.default.createElement(x_date_pickers_1.DesktopDatePicker, { ...desktopDatePickerProps });
}
exports.default = DatePickerX;
